import { useState } from 'react'
import { useFormsStore } from '../../../../stores/onboarding'
import { usePersonalStore } from '../../../../stores/personalInfo'
import { useInitializeStore } from '../../../../stores/initialize'
import Toast from 'react-native-toast-message'
import { globalStyles } from '../../../../static/styles/global'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import HomeDetailsHeader from '../../../home/HomeDetailsHeader'
import Card from '../../../shared/card/Card'
import CustomButton from '../../../shared/button/Button'
import Canvas from '../../../canvas'
import moment from 'moment'


const TODAY = moment().format('MM/DD/YYYY')

const HandBookSignOffOnline = ({ navigation, route }) => {
    const { essUserOnBoardingKey, essUserOnBoardingFormKey, values } = route.params
    const { loading, postHandBookSignOff } = useFormsStore(state => ({
        loading: state.loading,
        postHandBookSignOff: state.postHandBookSignOff,
    }))
    const [hasDrawn, setHasDrawn] = useState()
    const [signatureDataURL, setSignatureDataURL] = useState('')
    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const data = {
        completeOnline: true,
        essUserKey: intializestore.initializeData.userkey,
        entityId: personalstore.personalData?.entityId,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        essObKey: essUserOnBoardingKey,
        sign: signatureDataURL,
        initials: values?.initials?.toUpperCase()
    }
    const handleSubmit = async () => {
        try {
            const response: any = await postHandBookSignOff(data)
            const isSuccess = response?.success === true
            const message =
                response?.message || (isSuccess ? 'Success' : 'Something went wrong')

            Toast.show({
                type: isSuccess ? 'success' : 'error',
                position: 'bottom',
                text1: message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: isSuccess
                    ? () => navigation.replace('OnboardingForms')
                    : undefined
            })
        } catch (error: any) {
            Toast.show({
                type: 'error',
                position: 'bottom',
                text1: error?.message || 'Something went wrong',
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title="JProuxl Handbook"
                    />
                </View>
            </View>

            <ScrollView>

                <Card
                    style={{
                        fontFamily: "Arial, Helvetica, sans-serif",
                        fontSize: "14px",
                        color: "#000",

                        lineHeight: "1.5"
                    }}
                >
                    <div style={{ marginBottom: "60px" }}>

                        <h2 style={{ textAlign: "left", fontWeight: "bold" }}>
                            Receipt of Employee Handbook and Employment-At-Will Statement
                        </h2>

                        <p>
                            I <span style={{ borderBottom: "1px solid #000", fontWeight: "bold" }}> {personalstore?.personalData?.firstName?.toUpperCase()}{' '}
                                {personalstore?.personalData?.middleInitial?.toUpperCase()}{' '}
                                {personalstore?.personalData?.lastName?.toUpperCase()}</span> have reviewed the following:
                        </p>

                        <p>
                            I understand that this Employee Handbook refers to current benefit plans
                            maintained by the company and that I must refer to the actual plan documents
                            and summary plan descriptions as these documents are controlling.
                        </p>

                        <p>
                            - How to identify minors including anyone appearing to be 50 and younger
                        </p>

                        <p>
                            - Approved hours of sales for New York State 8:00am to 9:00pm.
                        </p>

                        <p>
                            - Handling of intoxicated persons.
                        </p>

                        <p>
                            - Reviewed National state ID forms and their identifying characteristics.
                        </p>

                        <p>
                            I have read and understand the Vacation Policy in this Employee Handbook.
                        </p>

                        <p>
                            Initials :<span style={{ display: "inline-block", borderBottom: "1px solid", fontWeight: "bold" }}>{values?.initials?.toUpperCase()}</span> &nbsp;&nbsp;&nbsp;&nbsp; Date : <span style={{ display: "inline-block", fontWeight: "bold" }}>{TODAY}</span>
                        </p>

                        <p>
                            I also understand that if a written contract is inconsistent with the Employee
                            Handbook, the written contract is controlling.
                        </p>

                        <p>
                            If I have questions regarding the content or interpretation of this Employee
                            Handbook, I will ask the manager or a member of management.
                        </p>

                        <br />

                        <p>NAME: <span style={{ fontWeight: "bold" }}>{personalstore?.personalData?.firstName?.toUpperCase()}{' '}
                            {personalstore?.personalData?.middleInitial?.toUpperCase()}{' '}
                            {personalstore?.personalData?.lastName?.toUpperCase()}</span></p>
                        <br />

                        <p>DATE : <span style={{ fontWeight: "bold" }}>{TODAY}</span></p>
                        <br />
                        <span>
                            EMPLOYEE
                            SIGNATURE : </span>
                        <Canvas
                            setSignatureDataURL={setSignatureDataURL}
                            setHasDrawn={setHasDrawn}
                            hasDrawn={hasDrawn}
                        />
                    </div>
                    <div>
                        <h2 style={{ textAlign: "left", fontWeight: "bold" }}>
                            Receipt of Employee Handbook and Employment-At-Will Statement
                        </h2>
                        <p>
                            This is to acknowledge that I have received a copy of the Save-A-Lot Food Stores
                            Employee Handbook and I understand that it contains information about the
                            employment policies and practices of the company. I agree to read and comply
                            with this Employee Handbook. I understand that the policies outlined in this
                            Employee Handbook are management guidelines only, which in a developing
                            business will require changes from time to time. I understand that the company
                            retains the right to make decisions involving employment as needed in order to
                            conduct its work in a manner that is beneficial to the employees and the company.
                            I understand that this Employee Handbook supersedes and replaces any and all
                            prior Employee Handbooks and any inconsistent verbal or written policy
                            statements.
                        </p>

                        <p>
                            I understand that except for the policy of at-will employment, the company
                            reserves the right to revise, delete and add to the provisions of this Employee
                            Handbook at any time without further notice. All such revisions, deletions or
                            additions to the Employee Handbook will be in writing and will be signed by the
                            president of the company. I understand that no oral statements or representations
                            can change the provisions of this Employee Handbook.
                        </p>

                        <p>
                            I understand that this Employee Handbook is not intended to create contractual
                            obligations with respect to any matters it covers and that the Employee Handbook
                            does not create a contract guaranteeing that I will be employed for any specific
                            time period.
                        </p>

                        <p style={{ marginTop: "40px", fontWeight: "bold" }}>
                            THIS COMPANY IS AN AT-WILL EMPLOYER. THIS MEANS THAT REGARDLESS OF
                            ANY PROVISION IN THIS EMPLOYEE HANDBOOK, THE COMPANY OR I MAY
                            TERMINATE THE EMPLOYMENT RELATIONSHIP AT ANY TIME FOR ANY REASON,
                            WITH OR WITHOUT CAUSE OR NOTICE. NOTHING IN THIS EMPLOYEE
                            HANDBOOK OR IN ANY DOCUMENT OR STATEMENT, WRITTEN OR ORAL,
                            SHALL LIMIT THE RIGHT TO TERMINATE EMPLOYMENT AT WILL. NO OFFICER,
                            EMPLOYEE OR REPRESENTATIVE OF THE COMPANY IS AUTHORIZED TO ENTER
                            INTO AN AGREEMENT—EXPRESS OR IMPLIED—WITH ME OR ANY EMPLOYEE
                            FOR EMPLOYMENT FOR A SPECIFIED PERIOD OF TIME. ANY AGREEMENT TO
                            EMPLOYMENT FOR A SPECIFIED PERIOD OF TIME WILL BE PUT INTO WRITING
                            AND SIGNED BY THE PRESIDENT OF THE COMPANY.
                        </p>
                    </div>
                </Card>
                {loading ? (
                    <ActivityIndicator />
                ) : (
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() => navigation.navigate('HandBookSignOffForm', { essUserOnBoardingKey, essUserOnBoardingFormKey })}
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handleSubmit}
                        />
                    </View>
                )}

            </ScrollView>
        </>
    )
}

export default HandBookSignOffOnline
